<footer class="text-center text-lg-start bg-light text-muted">
  <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.05)">
    © 2024 Copyright ESI Srl - versione 1.1
  </div>
</footer>
